import { useState } from 'react';
import { ProductSelectorWrapper } from './ProductSelectorWrapper';

export const ProductSelectorContainer = ({ selectorConfig, item, labelsStore, handleConfigClick }) => {
  const [selector, setSelector] = useState(null);

  const handlePsConfiguratorClick = () => {
    if (selector) {
      handleConfigClick(selector);
    }
  };

  return (
    <>
      {item.codification && (
        <a className="edit-conf" onClick={handlePsConfiguratorClick}>
          {selectorConfig && <ProductSelectorWrapper config={selectorConfig} labelsStore={labelsStore} setSelector={setSelector} />}
        </a>
      )}
      {item.backURL && (
        <a href={item.backURL || ''} target="_blank" rel=" noreferrer" className="edit-conf">
          {selectorConfig && <ProductSelectorWrapper config={selectorConfig} labelsStore={labelsStore} setSelector={setSelector} />}
        </a>
      )}
    </>
  );
};